import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Content, Icon, Input } from 'rsuite';
import { setStateValue } from '../../../../../actions/actionsModuloRelatorio';
import { LoadingSpinerArea } from '../../../../../components/LoadingSpinner';
import ModalConfirm from '../../../../../components/ModalConfirm';
import { trackEvent } from '../../../../../utils/MatomoConfig';
import SavedReportTable from '../Components/SavedReportTable';
import { useGenerateReportItem, useGetSavedReport, useRemoveReportItem } from '../Hooks';
import { fileDownloadStatus } from '../data';

const SavedReportContent = ({ goToContent }) => {
  const history = useHistory();

  const [reportData, setReportData] = useState({ id: '', fileName: '' });

  const { savedReportData, showModalDeleteSavedReport, showModalProcessingReport } = useSelector(
    state => ({
      savedReportData: state.moduloRelatorioDataReducer?.savedReportData,
      showModalDeleteSavedReport: state.moduloRelatorioDataReducer?.showModalDeleteSavedReport,
      showModalProcessingReport: state.moduloRelatorioDataReducer?.showModalProcessingReport,
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();

  const { handleSavedReportChangePage, handleSavedReportSearch, savedReportIsLoading } = useGetSavedReport();

  const { handleRemoveReport } = useRemoveReportItem();

  const { handleGenerateReportItem } = useGenerateReportItem();

  const handleSelectThreeDotButtonOption = (key, rowData) => {
    const { id, fileName } = rowData;

    setReportData(prevState => ({ ...prevState, id, fileName }));

    const actions = {
      1: () => history.push(`/isa/modulo-relatorio/${id}`),
      2: () => dispatch(setStateValue('showModalDeleteSavedReport', true)),
      3: () => {
        trackEvent('Módulo de relatórios', 'Gerar relatório agora');
        handleGenerateReportItem(id);
      },
    };

    actions[key]?.();
  };

  const handleChangeTab = type => {
    dispatch(setStateValue('showModalProcessingReport', false));
    goToContent(type);
  };

  return (
    <Content className="saved-report-content">
      <LoadingSpinerArea area="generate-report-now" size="md" />
      <div className="content-title-wrapper">
        <p className="content-title">Meus relatórios</p>
        <div className="input-search-wrapper">
          <Icon icon="search" style={{ color: '#1473E6' }} />
          <Input className="input-search-report" placeholder="Pesquise pelo nome do relatório" onChange={handleSavedReportSearch} />
        </div>
      </div>
      <SavedReportTable
        data={savedReportData}
        loading={savedReportIsLoading}
        setPage={handleSavedReportChangePage}
        onSelectThreeDotButtonOption={handleSelectThreeDotButtonOption}
      />
      <ModalConfirm
        show={showModalProcessingReport}
        modalWidth="590px"
        titleFontSize="20px"
        textAlign="center"
        footerAlign="center"
        icon={fileDownloadStatus.showModalConfirmDownload.icon}
        closeButton={false}
        title={fileDownloadStatus.showModalConfirmDownload.title}
        message={fileDownloadStatus.showModalConfirmDownload.message}
        confirmButton={fileDownloadStatus.showModalConfirmDownload.confirmButton}
        cancelButton={fileDownloadStatus.showModalConfirmDownload.cancelButton}
        onCancel={() => handleChangeTab('CRIAR_RELATORIO')}
        onConfirm={() => handleChangeTab('HISTORICO_RELATORIOS')}
      />
      <ModalConfirm
        show={showModalDeleteSavedReport}
        modalWidth="408px"
        titleFontSize="20px"
        textAlign="center"
        footerAlign="center"
        closeButton={false}
        title="Excluir relatório salvo?"
        message={`Tem certeza que deseja excluir o relatório ${reportData?.fileName}?`}
        confirmButton="EXCLUIR"
        cancelButton="CANCELAR"
        onCancel={() => dispatch(setStateValue('showModalDeleteSavedReport', false))}
        onConfirm={() => handleRemoveReport(reportData?.id)}
      />
    </Content>
  );
};

export default SavedReportContent;
